import { get } from 'core/communcation/api';

export const getTokenForReport = (id) => {
    return get(`reporting/datatokens/${id}`, null, true);
};
